import React from "react";
import { Leaf, Sprout, Wind } from "lucide-react";
import PaperCharm from "./PaperCharm";

const charms = [
  { Icon: Leaf, side: "left", top: "10%", delay: "-2s" },
  { Icon: Sprout, side: "right", top: "23%", delay: "-5s" },
  { Icon: Wind, side: "left", top: "45%", delay: "-7s" },
  { Icon: Leaf, side: "right", top: "64%", delay: "-1s" },
  { Icon: Sprout, side: "left", top: "79%", delay: "-4s" },
  { Icon: Leaf, side: "right", top: "43%", delay: "-3s" },
  { Icon: Leaf, side: "left", top: "28%", delay: "-6s" },
];

export default function SeasonalDecorations() {
  return (
    <div className="seasonal-decorations" aria-hidden="true">
      {charms.map(({ Icon, side, top, delay }, index) => (
        <span key={index} className={`drifting-charm charm-${side}`} style={{ top, animationDelay: delay }}>
          <Icon size={17} strokeWidth={1.5} />
        </span>
      ))}
      <div className="storybook-footer">
        <div className="footer-paper footer-paper-back" />
        <div className="footer-paper footer-paper-front" />
        <PaperCharm kind="pinecone" className="footer-pinecone" />
        <PaperCharm kind="lantern" className="footer-lantern" />
      </div>
    </div>
  );
}
